module.exports = __webpack_public_path__ + "static/media/items.a4b00939.jpg";